import { render, staticRenderFns } from "./GatGrid.vue?vue&type=template&id=237a85ba&scoped=true"
import script from "./GatGrid.vue?vue&type=script&lang=js"
export * from "./GatGrid.vue?vue&type=script&lang=js"
import style0 from "./GatGrid.vue?vue&type=style&index=0&id=237a85ba&prod&scoped=true&lang=scss"
import style1 from "./GatGrid.vue?vue&type=style&index=1&id=237a85ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237a85ba",
  null
  
)

export default component.exports